module.exports = __webpack_public_path__ + "media/assets/login/icon-meditation-6ed93d778632dacef71538f980de0046.svg";